import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { RootStore } from "../Store";
import { FilterStore } from "../FilterStore";
import moment from "antd/node_modules/moment";

export class IdChecksStore {
  store: RootStore;

  filterStore: FilterStore;
  filter: any = {
    page: 0,
    size: 100,
    status: "Pending",
    period: [undefined, undefined],
  };
  sortedInfo = { columnKey: "createDate", order: "descend" };

  loading = false;
  saving = false;
  isReject = false;

  selected: any;

  data = {
    total: 0,
    items: [],
  };

  constructor(store: RootStore) {
    makeAutoObservable(this, {
      store: false,
      pagination: computed,
    });
    this.store = store;
    this.filterStore = new FilterStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const status = params.get("status") || "Pending";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { status, period, page, size };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { period, status, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : undefined;

    const filter: any = {
      status,
      page,
      size,
      sorts,
    };

    return Api.idcheck
      .list(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.userVerifications;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }

}
